import React, { useState, useRef } from "react";
import { Box, Tooltip, IconButton } from "@mui/material";
import NoteIcon from "@mui/icons-material/Note";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

const Note = ({
	note,
	onEdit,
	onDelete,
	editMode = false,
}) => {
	const [showTooltip, setShowTooltip] = useState(false);
	const isTouchRef = useRef(false);

	const hasEmoji = note.emoji && note.emoji.trim() !== "";

	return (
		<Box
			className="template-item"
			data-template-item
			sx={{
				position: "relative",
				zIndex: 1054,
				pointerEvents: "auto",
				cursor: "pointer",
			}}
			onMouseEnter={() => {
				if (!isTouchRef.current) setShowTooltip(true);
			}}
			onMouseLeave={() => {
				if (!isTouchRef.current) setShowTooltip(false);
			}}
			onTouchEnd={(e) => {
				if (!editMode) {
					e.stopPropagation();
					isTouchRef.current = true;
					setShowTooltip((prev) => !prev);
					setTimeout(() => { isTouchRef.current = false; }, 400);
				}
			}}
			onClick={(e) => {
				if (isTouchRef.current) return;
				if (!editMode) {
					e.stopPropagation();
					setShowTooltip((prev) => !prev);
				}
			}}
		>
			<Tooltip
				open={showTooltip}
				title={
					<Box
						sx={{
							maxWidth: 250,
							padding: 0.5,
							fontSize: 12,
							color: "#475569",
							whiteSpace: "pre-wrap",
							wordBreak: "break-word",
							lineHeight: 1.5,
						}}
					>
						{note.content || "Sin contenido"}
					</Box>
				}
				arrow
				placement="top"
				PopperProps={{
					modifiers: [
						{
							name: "offset",
							options: {
								offset: [0, 8],
							},
						},
					],
				}}
				componentsProps={{
					tooltip: {
						sx: {
							backgroundColor: "#ffffff",
							maxWidth: 300,
							padding: "12px 16px",
							borderRadius: "12px",
							boxShadow: "0 4px 20px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.08)",
							border: "1px solid #e2e8f0",
						},
					},
					arrow: {
						sx: {
							color: "#ffffff",
							"&::before": {
								border: "1px solid #e2e8f0",
							},
						},
					},
				}}
			>
				<Box
					sx={{
						position: "relative",
						display: "flex",
						alignItems: "center",
						justifyContent: "center",
						flexDirection: "column",
						gap: 0.5,
					}}
				>
					<Box
						sx={{
							width: 30,
							height: 30,
							borderRadius: "50%",
							backgroundColor: "#ffffff",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							boxShadow: "0 2px 6px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.08)",
							transition: "transform 0.2s ease",
							cursor: "pointer",
							border: "1.5px solid #e2e8f0",
							"&:hover": {
								transform: "scale(1.08)",
							},
						}}
						onClick={(e) => {
							if (editMode && onEdit) {
								e.stopPropagation();
								onEdit(note);
							}
						}}
					>
						{hasEmoji ? (
							<Box sx={{ fontSize: 15, lineHeight: 1 }}>{note.emoji}</Box>
						) : (
							<NoteIcon
								sx={{
									fontSize: 16,
									color: "#6366F1",
								}}
							/>
						)}
					</Box>
					{editMode && (
						<Box
							sx={{
								display: "flex",
								gap: 0.25,
								backgroundColor: "white",
								borderRadius: "16px",
								padding: "2px 4px",
								boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
							}}
						>
							{onEdit && (
								<IconButton
									size="small"
									onClick={(e) => {
										e.stopPropagation();
										onEdit(note);
									}}
									sx={{
										padding: 0.2,
										"&:hover": {
											backgroundColor: "rgba(47, 127, 224, 0.1)",
										},
									}}
								>
									<EditIcon sx={{ fontSize: 12, color: "#64748b" }} />
								</IconButton>
							)}
							{onDelete && (
								<IconButton
									size="small"
									onClick={(e) => {
										e.stopPropagation();
										onDelete(note.id);
									}}
									sx={{
										padding: 0.2,
										"&:hover": {
											backgroundColor: "rgba(239, 68, 68, 0.1)",
										},
									}}
								>
									<DeleteIcon sx={{ fontSize: 12, color: "#ef4444" }} />
								</IconButton>
							)}
						</Box>
					)}
				</Box>
			</Tooltip>
		</Box>
	);
};

export default Note;
